import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";
import { SwitchValue } from "components/special/forms";

export const AssistantCriterias = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <div className="row">
                <div className="col-8">
                  <input
                    type="string"
                    name="attrName"
                    className="form-control"
                    placeholder={intl.formatMessage({ id: "OpenAI.Assistants.Criterias.attrName" })}
                    value={elem.attrName || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
                <div className="col-4">
                  <SwitchValue
                    value={elem.valueBoolean}
                    name="valueBoolean"
                    labelOff="False"
                    labelOn="True"
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: !!target.value });
                      changeValues(values);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col text-right">
              <AssistantCriterias.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

AssistantCriterias.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValue = () => {
    changeValues(values.concat([{}]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
  );
};

AssistantCriterias.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default AssistantCriterias;
